/* unplugin-vue-components disabled */import { render } from "./ellipsis.vue?vue&type=template&id=c9be8efe&scoped=true"
import script from "./ellipsis.vue?vue&type=script&lang=js"
export * from "./ellipsis.vue?vue&type=script&lang=js"

import "./ellipsis.vue?vue&type=style&index=0&id=c9be8efe&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9be8efe"],['__file',"src/controls/ellipsis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9be8efe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9be8efe', __exports__)) {
    api.reload('c9be8efe', __exports__)
  }
  
  module.hot.accept("./ellipsis.vue?vue&type=template&id=c9be8efe&scoped=true", () => {
    api.rerender('c9be8efe', render)
  })

}


export default __exports__